import { call, query } from "./calls";

export const File = {
    getUrlSigned: (values) => call("/storage", "POST", values, null, false, ""),
    createFile: (values) => call("/File", "POST", values),
    getByIds: (values) => query(`SELECT id, completeName FROM File where id in (${values.join(',')})`),
    get: (id) => query(`SELECT * from File where id=${id}`) 
}
